module.exports = __webpack_public_path__ + "img/robotProject.1e66211e.svg";